<template>
  <div>功能4</div>
</template>
<script>
export default {
  name: 'Header',
  components: {
  },
  data(){
    return {
    }
  },
  created: function () {
  },
  computed: {
  },
  watch: {
  },
  mounted: function(){
    console.log('功能4 mounted')
  },
  destroyed: function(){
    console.log('功能4 destroyed')
  },
  methods: {
  },
}
</script>